import { SchemaPath, validate } from '@angular/forms/signals';

export function prefix(path: SchemaPath<string>) {
  validate(path, ({ value }) => {
    const v = value();
    if (!v) {
      return null
    }

    if (!v.startsWith('/')) {
      return {
        kind: 'prefix',
        message: 'Must start with \'/\'',
      };
    }

    if (!v.endsWith('/')) {
      return {
        kind: 'prefix',
        message: 'Must end with \'/\'',
      };
    }

    return null;
  });
}
